import { createContext } from 'react'


const UserContext = createContext<{ loginUser: any, setLoginUser: any }>
    ({ loginUser: null, setLoginUser: null });

export const UserProvider = UserContext.Provider
export const UserConsumer = UserContext.Consumer

export default UserContext
